import { createFileRoute } from '@tanstack/react-router'
import { BotApiKeys, BotConfigurationVariables, BotDangerZone } from '~/features/bots/components/settings'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useIsAuthorized } from '~/hooks'
import { botQueryOptions } from '~/queries'
import { Separator } from '@bpinternal/ui-kit-next'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/settings/general')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, botId } = Route.useParams()

  const bot = useSuspenseQuery(botQueryOptions({ botId, workspaceId })).data
  const { user } = Route.useRouteContext()
  const authorize = useIsAuthorized({ workspaceId, userId: user.id })

  return (
    <div className="flex flex-col gap-8">
      <BotApiKeys botId={botId} workspaceId={workspaceId} />
      <Separator />
      <BotConfigurationVariables bot={bot} workspaceId={workspaceId} authorize={authorize} />
      <Separator />
      <BotDangerZone botId={botId} workspaceId={workspaceId} botName={bot.name} />
    </div>
  )
}
